import styled from 'styled-components';

const LiveBarHolder = styled.div`
	.live-bar {
		position: absolute;
		top: 75px;
		background: rgba(32, 39, 45, 0.9);
		width: 100%;
		padding: 25px;
		z-index: -1;
	
		@media only screen and (max-width: 748px) {
			display: none;
		}
	}
	.hidden {
		visibility: hidden !important;
		clip: rect(1px,1px,1px,1px);
		position: absolute!important;
		height: 1px;
		width: 1px;
		overflow: hidden;
	}
	.live-container {
		padding: 0;
    	margin: 0;
		display: grid;
		grid-template-columns: repeat(4,1fr);
		grid-template-rows: auto;
		gap: 15px 15px;

		@media only screen and (max-width: 1120px) {
			grid-template-columns: repeat(3,1fr);
		}

		@media only screen and (max-width: 868px) {
			grid-template-columns: repeat(2,1fr);
		}

		li {
			list-style: none;
		}
		p {
			cursor:default;
		}

		&__item {
			position: relative;

			&__header {
				position: relative;
				padding-top: calc(( 9 * var(--aspect-ratio-image-width)) / 16);

				img {
					position: absolute;
					width: var(--aspect-ratio-image-width);
					height: calc(( 9 * var(--aspect-ratio-image-width)) / 16);
					object-fit: contain;
					top: 0;
					left: 0;
					cursor: pointer;
				}

				.f-item {
					cursor: default !important;
				}
			}

			&__category {
			display:block;
			text-decoration: none;
			padding: 10px 0px 5px 0px;
			font-weight: 700;
			color: #d2d9df;
			text-transform: uppercase;
			margin: 0;
			font-size: 14px;
			cursor:pointer;
				&:hover {
					//color: black;
				}
			}

			&__title {
				font-family: "Open Sans", sans-serif;
				display:block;
				text-decoration: none;
				padding: 0px 0px 15px 0px;
				color: white;
				font-weight: 500;
				margin: 0;
				font-size: 17px;
				cursor:pointer;
				&:hover {
					//color: black;
				}
			}

			.t-l {
				position: absolute;
				top: -1%;
				left: 1%;
				z-index: 1;
			}

			&__live-info {
				font-family: "Open Sans", sans-serif;
				position: absolute;
				bottom: 0;
				background: black;
				color: white;
				width: 100%;
				height: 30px;
				z-index: 1;
				text-align: center;
				font-weight: 900;
				opacity: 0.8;
				line-height: 28px;
				font-size:17px;
			}

			&__cpactv {
				position: absolute;
				top: 0;
				right: 0;
				background-color: black;
				color: white;
				font-weight: 700;
				width: 120px;
   				height: 30px;
				img {
					display:inline-block;
					height:100%;
					width: auto;
					min-height: auto;
				}
				span {
					position: absolute;
					top: 5px;
				}
			}
		}
	}
`;

export default LiveBarHolder;